import { gql } from "generated/gql"

export const DISTRIBUTION_LIST_FIELDS = gql(`
  fragment DistributionListFields on DistributionList {
    id
    name
    usedInCount
    description
    recipients
    updatedAt
    createdBy {
      id
      name
      email
    }
  }
`)

export const GET_DISTRIBUTION_LISTS_QUERY = gql(`
  query GetDistributionLists($userId: ID) {
    distributionLists(userId: $userId) {
      ...DistributionListFields
    }
  }
`)

export const CREATE_DISTRIBUTION_LIST_MUTATION = gql(`
  mutation CreateDistributionList(
    $name: String!,
    $description: String,
    $recipients: [String!]!,
    $createdById: ID,
    $organizationId: ID!
  ) {
    createDistributionList(input: {
      name: $name
      description: $description
      recipients: $recipients
      createdById: $createdById
      organizationId: $organizationId
    }) {
      id
      errors
      distributionList {
        ...DistributionListFields
      }
    }
  }
`)

export const UPDATE_DISTRIBUTION_LIST_MUTATION = gql(`
  mutation UpdateDistributionList(
    $id: ID!,
    $name: String!
    $description: String
    $recipients: [String!]!
  ) {
    updateDistributionList(input: {
      id: $id
      name: $name
      description: $description
      recipients: $recipients
    }) {
      id
      errors
      distributionList {
        ...DistributionListFields
      }
    }
  }
`)

export const DESTROY_DISTRIBUTION_LIST_MUTATION = gql(`
  mutation DestroyDistributionList(
    $id: ID!,
  ) {
    destroyDistributionList(input: {
      id: $id
    }) {
      id
      errors
      distributionList {
        ...DistributionListFields
      }
    }
  }
`)
